module.exports = __webpack_public_path__ + "img/HZ3606-173.fe29432c.jpg";